// import VueCompositionAPI from "@vue/composition-api";
import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import App from './App.vue';
import router from './router/index';
import store from './store/index';
import vuetify from './plugins/vuetify';
import login from './firebase/login';
import './filters';
import './plugins/clipboard';
import i18n from './i18n';
import stripeOptions from './plugins/stripe';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: "https://11678549c6df4cd6aca66546c43eb651@o941373.ingest.sentry.io/5890228",
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.use(StripePlugin, stripeOptions);
Vue.use(VueYouTubeEmbed);
// Vue.use(VueCompositionAPI);

let app = null;
let isSignedIn = false;
// wait for firebase auth to init before creating the app
login.waitForLogin((user) => {
  console.log('waitForLogin');
  // init app if not already created
  const { firUser } = store.state;
  store.commit('firUserUpdated', user);
  if (user) {
    isSignedIn = true;
    console.log('waitForLogin->Logged in user', user.uid);
    store.dispatch('userLogedIn', user);
    store.dispatch("getTrips");
    if (router.currentRoute.meta && router.currentRoute.meta.isForLogin) {
      if (router.startUrl) {
        console.log(`pushing to  ${router.startUrl}`);
        router.push({ path: router.startUrl });
      } else {
        router.push({ name: "Home" });
      }
    }
  } else if (isSignedIn) {
    isSignedIn = false;
    router.push({ name: "Login" });
    store.dispatch("logOut", firUser);
  }

  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: (h) => h(App),
    }).$mount('#app');
  }
});
